import React from 'react';
interface CTAButtonProps {
  text: string;
  icon?: React.ReactNode;
  primary?: boolean;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text,
  icon,
  primary = false,
  onClick,
  className = ''
}: CTAButtonProps) {
  const baseClasses = 'flex items-center justify-center gap-2 px-4 sm:px-6 py-2 sm:py-3 rounded-lg sm:rounded-xl font-medium transition-all duration-200 text-center';
  const primaryClasses = 'bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg';
  const secondaryClasses = 'bg-white dark:bg-gray-800 text-gray-800 dark:text-white border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700';
  return <button onClick={onClick} className={`${baseClasses} ${primary ? primaryClasses : secondaryClasses} ${className}`} data-id="element-257">
      {icon}
      <span data-id="element-258">{text}</span>
    </button>;
}